import "./style/style.scss";

import AuthPage from "@pages/AuthPage";
import MainPage from "@pages/MainPage";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";


const isAuthenticated = () => {
  return !!localStorage.getItem("token");
};

const App = () => {
  return (
    <BrowserRouter>
      <Routes>

        <Route
          path="/"
          element={
            isAuthenticated() ? <MainPage /> : <Navigate to="/login" replace />
          }
        />
        <Route path="/login" element={<AuthPage />} />
        {/* если путь не совпал */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;